import { render, staticRenderFns } from "./pointsDetails.vue?vue&type=template&id=73d5d142&scoped=true&"
import script from "./pointsDetails.vue?vue&type=script&lang=js&"
export * from "./pointsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d5d142",
  null
  
)

export default component.exports